import script from "./TransactionIframe.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionIframe.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionIframe.vue?vue&type=style&index=0&id=732751ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732751ca"]])

export default __exports__